import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"width":"500","max-width":"90%","persistent":""},model:{value:(_vm.isShowPopup),callback:function ($$v) {_vm.isShowPopup=$$v},expression:"isShowPopup"}},[_c(VCard,[_c(VCardTitle,{staticClass:"headline grey lighten-2 pr-10",attrs:{"primary-title":""}},[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),_c(VSpacer),_c(VBtn,{attrs:{"text":"","icon":"","color":"black","absolute":"","top":"","right":""},on:{"click":function($event){return _vm.$emit('on-close')}}},[_c(VIcon,[_vm._v("mdi-close")])],1)],1),_c(VCardText,[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }